import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";

interface GameHomeProps extends PageProps<{}> {
}

class GameHome extends React.Component<GameHomeProps> {
    constructor(props: GameHomeProps) {
        super(props);
        bindAllOfThis(this, GameHome.prototype);
    }

    render() {
        return (<div>Hey you just made the GameHome component, woot!</div>);
    }
}

export default GameHome;



// WEBPACK FOOTER //
// ./src/pages/game/Home.tsx